<template>
  <!-- This example requires Tailwind CSS v2.0+ -->
  <div>
    <div class="mt-4">
      <el-input
        class="dashboard-session-search"
        placeholder="Search by email"
        prefix-icon="el-icon-search"
        v-model="search"
        id="dashboard-session-search"
      ></el-input>
      <div class="sm:float-right mt-4 sm:mt-0 space-x-2">
        <el-select class="dashboard-session-selection" v-model="sessionSelection" multiple placeholder="Filter" id="dashboard-session-filter">
          <el-option v-for="item in sessionSelectOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
        <el-button
          v-if="showExport"
          type="plain"
          class="border-brand-gray-blue px-4 rounded-lg text-brand-blue font-bold"
          style="border-width: 3px"
          size="small"
          @click="$store.dispatch('DOWNLOAD_SESSIONS')"
          icon="el-icon-download"
        >
          <span class="text-xs text-brand-blue font-semibold">Export</span>
        </el-button>
      </div>
    </div>
    <div class="clear-both"></div>
    <div class="overflow-hidden sm:rounded-md rounded-lg">
      <ul class="">
        <li
          v-for="session in displayedSessions"
          :key="session._id"
          class="bg-white shadow-sm rounded-lg border-2 border-brand-sand my-3 hover:bg-brand-light-sand transition-colors"
        >
          <div class="px-4 py-6 sm:px-6 my-0 flex flex-grow justify-start">
            <div class="w-16 flex-grow-0 flex-shrink-0">
              <font-awesome-icon
                v-if="session.recording"
                @click="view(session)"
                :icon="['fas', 'play-circle']"
                class="text-brand-medium-brown text-4xl mt-2 cursor-pointer hover:text-brand-blue transition-colors"
                id="session-playback-trigger"
              />
              <font-awesome-icon
                v-else
                @click="view(session)"
                :icon="['fas', 'video-slash']"
                class="text-brand-light-brown cursor-not-allowed text-3xl mt-2"
              />
            </div>
            <div class="flex-grow-1 w-full">
              <div class="flex items-center justify-between">
                <p class="text-sm font-semibold text-brand-brown truncate confidential-blurry-text">
                  <a class="hover:bg-gray-50 cursor-pointer confidential-blurry-text" @click="copyToClipboard(session.customer.email)">
                    {{ session.customer.email }}
                  </a>
                  <font-awesome-icon
                    :icon="['fas', 'paste']"
                    class="hover:opacity-80 opacity-40 ml-1 cursor-pointer"
                    @click="copyToClipboard(session.customer.email)"
                  />
                </p>
                <div class="ml-2 flex-shrink-0 flex">
                  <p v-if="session.canceled" class="px-4 py-1 inline-flex text-xs leading-5 font-semibold rounded-md bg-red-100 text-red-700">
                    Cancelled
                  </p>
                  <p
                    v-else-if="session.acceptedOffer && session.acceptedOffer.offerType === OFFER_TYPE.PAUSE"
                    class="px-4 py-1 inline-flex text-xs leading-5 font-semibold rounded-md bg-green-100 text-green-700"
                  >
                    Paused for {{ session.acceptedOffer.pauseDuration }} {{ session.acceptedOffer.pauseDuration === 1 ? 'month' : 'months' }}
                  </p>
                  <p
                    v-else-if="session.acceptedOffer && session.acceptedOffer.offerType === OFFER_TYPE.CONTACT"
                    class="px-4 py-1 inline-flex text-xs leading-5 font-semibold rounded-md bg-indigo-100 text-indigo-700"
                  >
                    Selected Contact
                  </p>
                  <p
                    v-else-if="session.acceptedOffer && session.acceptedOffer.offerType === OFFER_TYPE.REDIRECT"
                    class="px-4 py-1 inline-flex text-xs leading-5 font-semibold rounded-md bg-indigo-100 text-indigo-700"
                  >
                    Selected Redirect
                  </p>
                  <p
                    v-else-if="session.acceptedOffer && session.acceptedOffer.offerType === OFFER_TYPE.DISCOUNT"
                    class="px-4 py-1 inline-flex text-xs leading-5 font-semibold rounded-md bg-indigo-100 text-indigo-700"
                  >
                    Accepted Discount
                  </p>
                  <p v-else-if="session.aborted" class="px-4 py-1 inline-flex text-xs leading-5 font-semibold rounded-md bg-gray-50 text-gray-700">
                    Aborted Flow
                  </p>
                </div>
              </div>
              <div class="mt-2 sm:flex sm:justify-between">
                <ul class="text-sm text-brand-medium-brown font-medium customer-details">
                  <li>
                    <time class="ml-1" :datetime="session.createdAt">{{ session.createdAt | timeAgoDate }}</time>
                  </li>
                  <li v-if="session.customer && session.customer.billingInterval && session.customer.planPrice">
                    <span>${{ session.customer.planPrice / 100 }}</span>
                    <span>/</span>
                    <span class="lowercase" v-if="session.customer.billingIntervalCount > 1"
                      >{{ session.customer.billingIntervalCount }} {{ session.customer.bilingInterval }}s</span
                    >
                    <span class="lowercase">{{ session.customer.billingInterval }}</span>
                  </li>
                  <li v-if="session.customer.created">Subscribed {{ session.customer.created | timeAgoDate }}</li>
                  <li v-if="session.customer.onTrial">On trial</li>
                  <li v-if="session.surveyChoiceValue">
                    {{ session.surveyChoiceValue }}
                  </li>
                </ul>
                <!-- <div class="sm:flex">
                <p class="flex items-center text-sm text-brand-medium-brown font-medium mr-3">
                  <time class="ml-1" :datetime="session.createdAt">{{ session.createdAt | timeAgoDate }}</time>
                </p>
                <p
                  v-if="session.recording"
                  class="playback mt-2 flex items-center text-sm text-brand-medium-brown font-medium sm:mt-0 sm:mx-3 cursor-pointer hover:text-brand-brown"
                  @click="view(session)"
                >
                  <span>·</span>
                  <span class="ml-1"> View Session </span>
                </p>
                <p v-if="session.surveyChoiceId" class="mt-2 flex items-center text-sm text-brand-medium-brown font-medium sm:mt-0 sm:mx-3">
                  <span class="ml-1">
                    {{ surveyChoices[session.blueprintId][session.surveyChoiceId].value }}
                  </span>
                </p>
              </div> -->
                <div class="mt-2 mr-2 flex items-center text-xs text-brand-brown font-medium sm:mt-0">
                  <div>
                    <!-- more info about action -->
                    <div v-if="session.acceptedOffer && session.acceptedOffer.offerType === OFFER_TYPE.DISCOUNT">
                      <div v-if="session.acceptedOffer.couponType === DISCOUNT_TYPE.PERCENT">
                        <span class="">
                          {{ session.acceptedOffer.couponAmount }}% off&nbsp;
                          <span v-if="session.acceptedOffer.couponDuration">
                            <span v-if="session.acceptedOffer.couponDuration === 1"> one time </span>
                            <span v-else> for {{ session.acceptedOffer.couponDuration }} months </span>
                          </span>
                          <span v-else>for life</span>
                        </span>
                      </div>
                      <div v-else-if="session.acceptedOffer.couponType === DISCOUNT_TYPE.AMOUNT">
                        <span class=""> {{ discountCouponToString(session.acceptedOffer) }}&nbsp; </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="session.feedback" class="mt-4 text-xs text-brand-medium-brown">
                <span class="font-semibold">Feedback:</span>
                <span class="ml-1">{{ session.feedback }}</span>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="flex justify-center mt-4 dashboard-pagination">
        <el-pagination
          v-if="numPages > 1"
          layout="prev, pager, next, sizes"
          :page-size.sync="pageSize"
          :page-sizes="[5, 10, 20, 50, 100]"
          :current-page.sync="page"
          :total="filteredSessions.length"
          background
          id="dashboard-session-pagination"
        ></el-pagination>
      </div>
      <session-viewer
        class="dashboard-session-viewer"
        v-if="isVideoActive"
        :session="viewingSession"
        v-on:update:session="viewingSession = $event"
      ></session-viewer>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { ascending, descending } from 'd3';
import { OFFER_TYPE, DISCOUNT_TYPE, discountCouponToString } from '@/store/shared';
import { CopyToClipboard } from '@/mixins/copy-to-clipboard';
import SessionViewer from '@/components/SessionViewer.vue';

const sessionSelectOptions = [
  { label: 'Accepted Discount', value: OFFER_TYPE.DISCOUNT },
  { label: 'Accepted Pause', value: OFFER_TYPE.PAUSE },
  { label: 'Contacted Support', value: OFFER_TYPE.CONTACT },
  { label: 'Cancelled', value: 'canceled' },
];

export default {
  name: 'SessionList',
  components: {
    SessionViewer,
  },
  mixins: [CopyToClipboard],
  props: {
    sessions: {
      type: Array,
      default: () => [],
    },
    // only callback instead of player within component
    callback: {
      type: Boolean,
      default: false,
    },
    showExport: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      OFFER_TYPE,
      DISCOUNT_TYPE,
      viewingSession: null,
      isVideoActive: false,
      search: '',
      sessionSelectOptions,
      sessionSelection: [],
      page: 1,
      pageSize: 6,
      discountCouponToString,
    };
  },
  computed: {
    ...mapGetters(['surveyChoices']),
    filteredSessions() {
      const selectFilteredSessions = this.sessions.filter(this.matchesFilter);
      if (this.search) {
        const searchTerms = this.search.split(' ').map((t) => t.toLowerCase());
        // eslint-disable-next-line arrow-body-style
        return selectFilteredSessions.filter((p) => {
          return searchTerms.reduce((acc, term) => p.customer.email.toLowerCase().includes(term) && acc, true);
        });
      }
      // no search
      return selectFilteredSessions;
    },
    displayedSessions() {
      const minIndex = (this.page - 1) * this.pageSize;
      const maxIndex = this.page * this.pageSize - 1;
      return this.filteredSessions.filter((session, index) => index >= minIndex && index <= maxIndex);
    },
    numPages() {
      return Math.ceil(this.filteredSessions.length / this.pageSize);
    },
  },
  methods: {
    view(session) {
      if (this.callback) {
        this.$emit('view', session);
      } else {
        this.isVideoActive = true;
        this.viewingSession = session;
      }
    },
    matchesFilter(session) {
      if (this.sessionSelection.length) {
        if (this.sessionSelection.includes('canceled') && session.canceled) {
          return true;
        }
        if (session.acceptedOffer && this.sessionSelection.includes(session.acceptedOffer.offerType)) {
          return true;
        }
        return false;
      }
      return true;
    },
  },
};
</script>
<style lang="scss" scoped>
.customer-details {
  @apply list-none;
  li {
    display: inline;
  }
  li + li::before {
    content: '  ·  ';
  }
}
</style>

<style lang="scss">
.dashboard-pagination {
  .el-pagination.is-background {
    button.btn-prev {
      @apply bg-brand-sand;
      &:hover {
        @apply text-gray-800;
      }
    }
    button.btn-next {
      @apply bg-brand-sand;
      &:hover {
        @apply text-gray-800;
      }
    }
    li.btn-quicknext {
      @apply bg-brand-sand;
      &:hover {
        @apply text-gray-800;
      }
    }
    li.btn-quickprev {
      @apply bg-brand-sand;
      &:hover {
        @apply text-gray-800;
      }
    }
    ul.el-pager {
      li.number {
        @apply bg-brand-sand;
        &:hover {
          @apply text-gray-800;
        }
        &.active {
          @apply bg-brand-medium-brown;
          &:hover {
            @apply text-white;
          }
        }
      }
    }
  }
  .el-input {
    @apply shadow-sm;
    @apply rounded-lg;
    .el-select__caret {
      @apply text-brand-blue;
    }
    .el-input__inner {
      @apply border-brand-gray-blue;
      @apply rounded-lg;
      border-width: 2px;
      &::placeholder {
        @apply text-brand-gray-blue;
      }
    }
  }
}

.dashboard-session-search {
  max-width: 300px;
  @apply shadow-sm;
  @apply rounded-md;
  .el-input__icon {
    @apply text-brand-gray-blue;
  }
  .el-input__inner {
    @apply border-brand-gray-blue;
    @apply rounded-lg;
    border-width: 2px;
    &::placeholder {
      @apply text-brand-gray-blue;
    }
  }
}

.dashboard-session-selection {
  max-width: 400px;
  @apply shadow-sm;
  @apply rounded-md;
  .el-select__caret {
    @apply text-brand-gray-blue;
  }
  .el-input__inner {
    @apply border-brand-gray-blue;
    @apply rounded-lg;
    border-width: 2px;
    &::placeholder {
      @apply text-brand-gray-blue;
    }
  }
}
</style>
